export const AMENITY_GROUPS = [
  {
    key: "Bathroom",
    items: [
      "bathub",
      "hairdryer",
      "shower",
      "hotwater",
      "soapdrop",
      "heating",
      "toiletseat",
      "bathhanger",
    ],
  },
  {
    key: "Location features",
    items: ["swimmingpool", "valleyview", "park", "balcony"],
  },
  {
    key: "Bedroom and Laundry",
    items: [
      "trowelbrush",
      "hanger",
      "beddouble",
      "bed",
      "dresserdrawer",
      "dressingmirror",
      "safebox",
      "sofadouble",
      "washingmachine",
    ],
  },
  {
    key: "Entertainment",
    items: ["gamepad"],
  },
  {
    key: "Home safety",
    items: ["medicalcase", "fireextinguisher", "tvstand", "alarm", "cctv"],
  },
  {
    key: "Internet and office",
    items: ["wifi", "workjob", "laptoptable"],
  },
  {
    key: "Kitchen and dining",
    items: [
      "kitchen",
      "forkknife",
      "stove",
      "induction",
      "dishes",
      "fridge",
      "tablechair",
      "coffeemachine",
      "blender",
      "saltpepper",
      "dishwasher",
      "wineglass",
      "trash",
      "platefork",
    ],
  },
  {
    key: "Outdoor",
    items: ["beachumbrella", "childrenslide", "lounge", "sun", "swing"],
  },
  {
    key: "Parking and facilities",
    items: ["parking"],
  },
  {
    key: "Services",
    items: [
      "cat",
      "dog",
      "breakfast",
      "longterm",
      "housekey",
      "userprofile",
      "cleaningspray",
      "smoking",
      "campfire",
      "stairs",
      "manstaff",
      "womenstaff",
    ],
  },
  {
    key: "Family",
    items: ["toyscubes", "fairytale", "babybedroom"],
  },
  {
    key: "Heating and cooling",
    items: ["appliance", "fan"],
  },
  {
    key: "Others",
    items: [
      "CookwareKitchenUtensils",
      "DryingRack",
      "CableTv",
      "Toaster",
      "Wardrobe",
      "DiningTable",
      "Reception",
      "CityView",
      "SmokeDetectors",
      "MarinaView",
      "Gym",
      "CarbonMonoxideDetector",
      "Hangers",
      "TrashCans",
      "WineGlasses",
      "StreamingServiceSuchAsNetflix",
      "CrockeryCutlery",
      "Toilet",
      "Oven",
      "CoffeeMaker",
      "ComplimentarySoapShampooConditioner",
      "BeachView",
      "Elevator",
      "WirelessInternet",
      "FreeParkingWithGarage",
      "SmartTv",
      "FireExtinguisher",
      "Marina",
      "RoomDarkeningShades",
      "IronIroningBoard",
      "BedLinenTowels",
      "Kettle",
      "Microwave",
      "AirConditioning",
      "Seaview",
      "Beach",
      "PlayGround",
      "Refrigerator",
      "FamilyKidsFriendly",
      "NoParties",
      "Essentials",
      "CleaningProducts",
      "FirstAidKit",
      "CookingBasics",
      "SmokingNotAllowed",
    ],
  },
];

export const AMENITY_CATEGORIES = ["All", ...AMENITY_GROUPS.map((group) => group.key)];


